import { useBrand } from "./brand";

export function AppFooter() {
    const brand = useBrand();
    return (
        <footer className="flex h-4 shrink-0 items-center justify-center border-t border-border/50 bg-background px-4 text-[8px] text-muted-foreground/30 select-none">
            {brand.footerText || `© ${new Date().getFullYear()} ${brand.name}`}
        </footer>
    );
}
